import { render, staticRenderFns } from "./pending-delete-space.vue?vue&type=template&id=6214deab&scoped=true"
import script from "./pending-delete-space.vue?vue&type=script&lang=js"
export * from "./pending-delete-space.vue?vue&type=script&lang=js"
import style0 from "./pending-delete-space.vue?vue&type=style&index=0&id=6214deab&prod&scoped=true&lang=css"
import style1 from "./pending-delete-space.vue?vue&type=style&index=1&id=6214deab&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6214deab",
  null
  
)

export default component.exports